/**
 * The PIN gate is obfuscation, not cryptography: it keeps a curious guest out
 * of a device-local configuration, nothing more. Anyone with the tablet can
 * clear localStorage.
 */
export const PIN = {
  DEFAULT: '0000',
  LENGTH: 4,
  /** Wrong guesses allowed before a cool-down. */
  MAX_ATTEMPTS: 5,
  LOCKOUT_MS: 60_000,
} as const;

/** Idle minutes before the console locks itself again. */
export const AUTO_LOCK = {
  DEFAULT_MINUTES: 5,
  /** "Never" is stored as zero. */
  NEVER_MINUTES: 0,
  OPTIONS_MINUTES: [1, 5, 15, 30] as readonly number[],
} as const;

/** Gesture that reveals the console: rapid taps on the settings logo. */
export const SECRET_TAP = {
  REQUIRED_TAPS: 5,
  WINDOW_MS: 2_000,
} as const;
